import { useCallback } from 'react';
import { useAtomValue } from 'jotai';
import { kpiGroupsState } from '../services/state/KPI/KPITemplatesStateJ';
import { createField3DataModel, ISelectMeta } from '../data-models/field3.data-model';
import { RendererType } from '../data-models/field-definition';
import { ISimpleChoice } from '../data-models/field2.data-model';

export function useGetKPIGroupField() {
  const kpiGroups = useAtomValue(kpiGroupsState);

  return useCallback(
    (fieldId: string, label: string) => {
      const groups: ISimpleChoice<number>[] = kpiGroups.map((group) => {
        return {
          value: group.id,
          displayName: group.name,
        };
      });

      return createField3DataModel<ISelectMeta<number>>({
        entityKey: fieldId,
        displayName: label,
        format: RendererType.singleSelect,
        meta: {
          values: groups,
          multi: false,
          formatValueToLabel: true,
        },
      });
    },
    [kpiGroups]
  );
}
